import React, { useState, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import {
    Avatar,
    Box,
    Drawer,
    IconButton,
    List,
    ListItemIcon,
    ListItemText,
    Toolbar,
    Typography,
    ListItemButton,
    Badge,
    BadgeMark
} from "@mui/material";
import Divider from '@mui/material/Divider';
import { styled,useTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MenuIcon from '@mui/icons-material/Menu';
import MuiAppBar from '@mui/material/AppBar';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import HomeIcon from '@mui/icons-material/Home';
import StickyNote2 from '@mui/icons-material/StickyNote2';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import Newspaper from '@mui/icons-material/Newspaper'; 
import SaveAsIcon from '@mui/icons-material/SaveAs';
import UpdatePassword from '../update-password';
import Login from '../../components/login';
import NewsletterType from '../newsletter-type';
import Area from '../area';
import AreaReadOnly from '../area/area-readonly';
import Newsletter from '../newsletter'; 
import CampaingSource from '../newsletter/campaing-detail'; 
import RegisterCampaign from '../newsletter/register-campaing-detail'; 
import PendingNewslettersSource from '../newsletter/myNewsletter-detail'; 
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import TopicIcon from '@mui/icons-material/Topic';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import EngineeringIcon from '@mui/icons-material/Engineering';
import Tooltip from '@mui/material/Tooltip';
import EventNoteIcon from '@mui/icons-material/EventNote';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import ShortTextIcon from '@mui/icons-material/ShortText';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LineStyleIcon from '@mui/icons-material/LineStyle';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';

import { TITLES, MESSAGES } from '../../shared/constants';
import AcceptDialog from '../accept-modal';
import Home from '../home';

import Overtime from '../overtime';
import EmployeeWorkShif from '../employee-work-shif';
import PolyvalencePayment from '../employee-polyvalence';
import PendingSignatures from '../pending-signature';
import Signature from '../signature';
import { logout } from '../../shared/auth-service';
import ManageProfileOptions from '../gestion/management-position';
import ManagementProfile from '../gestion/management-profile';
import ManagementEmployee from '../gestion/management-employee';
import ManagementAirport from '../gestion/management-airport';
import ManagementZone from '../gestion/management-zone';
import ManagementCompany from '../gestion/management-company';
import ManagementUsability from '../gestion/management-usability';
import Compensation from '../compensation'
import PositionHomologationInform from '../position-homologation/position-homologation-inform'
import PositionHomologationEngrana from '../position-homologation/position-homologation-engrana'
import GroupHomologationReadOnly from '../position-homologation/position-homologation-source'
import UserQueryTalmaID from '../user-query-talma-id';
import ShiftManagement from '../shift-management';
import ShiftSegments from '../shift-segments';
import ShiftCalendar from '../shift-calendar';
import ShiftAbbreviation from '../shift-abbreviation';
import ShiftHistory from '../shift-history';
import ShiftHistoryChange from '../shift-history-change';
import ShiftImport from '../shift-import';
import EmployeeAbsencePermissions from '../employee-absence-permissions';
import EmployeeAbsencePermissionsAdmin from '../employee-absence-permissions-admin';
import EmployeeAbsencePermissionsConsult from '../employee-absence-permissions-consult';
import ShiftReadOnly from '../shift-management/shift-management-readonly';
import ShiftAbbreviationReadOnly from '../shift-abbreviation/shift-abbreviation-readonly';
import AbsenteeismSupport from '../AbsenteeismSupport';
import AbsenteeismSupportConsult from '../AbsenteeismSupport/AbsenteeismSupport-Consult';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import Collapse from '@mui/material/Collapse';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CallMissedOutgoingIcon from '@mui/icons-material/CallMissedOutgoing';
import PreviewIcon from '@mui/icons-material/Preview';
import Assessment from '../assessment';
import VacationRequest from '../vacation-request';
import VacationRequestConsult from '../vacation-request/vacation-request-consult';
import { isMobile } from 'react-device-detect';
import { RegisterUsabilityLog } from '../../shared/data-services/ModuleUsabilityLog-service';
import { BadgeRounded, Campaign,MyLocation, Domain, EmojiPeople, Flight, GroupAdd, ManageAccountsRounded, ManageSearch, MarkUnreadChatAlt, PlaylistAdd, PointOfSale, QrCodeScanner, SettingsAccessibility, SocialDistance, ChangeCircle, ChangeHistory, ChangeCircleOutlined, ZoomInMap,LocalAirportIcon, LineWeight, ContentPaste, ContentPasteSearch, Assignment, Luggage, PersonSearch,TravelExplore, Policy   } from '@mui/icons-material';
import { use } from 'react';

const drawerWidth = 240;


const logoStyles = {
    width: 180,
    margin: '5px auto',
} 

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));



const Dashboard = props => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(null);
  const [selectedIndexMenu, setSelectedIndexMenu] = React.useState([0, 0]);
  const [companyName, setCompanyName] = useState("");

  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  useEffect(() => {
    var selectedCompany = "";
    const storedUser = JSON.parse(sessionStorage.getItem("user"));
    if (storedUser && storedUser.countryCode) {
      if (storedUser.companies.length == 1)
        selectedCompany = storedUser.companies[0].shortName;
      else
        selectedCompany = storedUser.countryCode.split('-')[1];

      setCompanyName(selectedCompany);
    }
  }, []);

 const handleClickItemOpen = (index, subIndex, navigateUrl, text) => {
  // Si es clic sobre el mismo padre y es solo un desplegable (sin navegación)
  if (subIndex === -1) {
    setOpenMenuIndex(prev => prev === index ? null : index);
    setSelectedIndexMenu([index, -1]);
  } else {
    setSelectedIndexMenu([index, subIndex]);
    setOpenMenuIndex(index);
  }

   if (navigateUrl !== '') {
    if (isMobile) setOpen(false);

    // Evitar registrar log desde aquí si es "Mis Turnos"
    if (navigateUrl !== '/ShiftCalendar') {
      RegisterUsabilityLog(text, user.employeeId);
    }

    navigate(navigateUrl);
  }
};


  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  
  const { user } = props;
  const navigate = useNavigate();
  const [itemList] = useState([
    {
      code: '0',
      text: 'Inicio',
      icon: <HomeIcon/>,
      sort: 1,
      onClick: () => handleClickItemOpen(0, 0, '/', 'Inicio'),
      subItems: []
    }
    ,
    {
      code: 'DEOPP0001',
      text: 'Autogestión',
      icon: <EngineeringIcon />,
      sort: 2,
      onClick: () => handleClickItemOpen(1, -1, '', 'Autogestión'),
      subItems: [
        // {
        //   subCode: 'DEOP0001',
        //   subText: 'Horas Extras',
        //   subIcon: <MoreTimeIcon />,
        //   subSort: 1,
        //   onClick: () => handleClickItemOpen(1, 0, '/Overtime', 'Horas Extras - Autogestión')
        // },   
        {
          subCode: 'DEOP0014',
          subText: 'Mis Turnos',
          subIcon: <CalendarMonthIcon />,
          subSort: 1,
          onClick: () => handleClickItemOpen(1, 0, '/ShiftCalendar', 'Mis Turnos - Autogestión')
        },
        {
          subCode: 'DEOP0015',
          subText: 'Solicitud Permisos y Ausencias',
          subIcon: <CallMissedOutgoingIcon />,
          subSort: 2,
          onClick: () => handleClickItemOpen(1, 1, '/EmployeeAbsencePermissions', 'Solicitud Permisos y Ausencias - Autogestión')
        },
        {
          subCode: 'DEOP0038',
          subText: 'Solicitud Vacaciones',
          subIcon: <Luggage />,
          subSort: 3,
          onClick: () => handleClickItemOpen(1, 2, '/VacationRequest', 'Solicitud Vacaciones - Autogestión')
        },
        {
          subCode: 'DEOP0002',
          subText: 'Mis Marcaciones',
          subIcon: <AlarmOnIcon />,
          subSort: 4,
          onClick: () => handleClickItemOpen(1, 3, '/EmployeeWorkShif', 'Mis Marcaciones - Autogestión')
        }
        // {
        //   subCode: 'DEOP0003',
        //   subText: 'Polivalencia',
        //   subIcon: <ConnectingAirportsIcon />,
        //   subSort: 3,
        //   onClick: () => handleClickItemOpen(1, 2, '/PolyvalencePayment', 'Polivalencia -Autogestión')
        // },
        ,
        // {
        //   subCode: 'DEOP0033',
        //   subText: 'Admin Ausencias y Permisos',
        //   subIcon: <SupervisorAccountIcon />,
        //   subSort: 5,
        //   onClick: () => handleClickItemOpen(1, 4, '/EmployeeAbsencePermissionsAdmin', 'Admin Ausencias y Permisos - Autogestión')
        // },
      ]
    }, 
    {
      code: 'DEOPP0002',
      text: 'Circulares',
      icon: <TopicIcon />,
      sort: 3,
      onClick: () => handleClickItemOpen(2, -1, ''),
      subItems: [
        {
          subCode: 'DEOP0004',
          subText: 'Tipo Circulares',
          subIcon: <StickyNote2 />,
          subSort: 1,
          onClick: () => handleClickItemOpen(2, 0, '/NewsletterType', 'Tipo Circulares - Circulares')
        },
        {
          subCode: 'DEOP0005',
          subText: 'Circulares',
          subIcon: <Newspaper />,
          subSort: 2,
          onClick: () => handleClickItemOpen(2, 1, '/Newsletter', 'Circulares - Circulares'), 
        },
        // {
        //   subCode: 'DEOP0006',
        //   subText: 'Mis Circulares',
        //   subIcon: <SaveAsIcon />,
        //   subSort: 3,
        //   onClick: () => handleClickItemOpen(2, 2, '/PendingSignatures', 'Mis Circulares - Circulares')
        // },
        {
          subCode: 'DEOP0012',
          subText: 'Evaluaciones',
          subIcon: <QuestionAnswerIcon />,
          subSort: 4,
          onClick: () => handleClickItemOpen(2, 2, '/Assessment', 'Evaluaciones - Circulares')
        },
        {
          subCode: 'DEOP0026',
          subText: 'Campañas',
          subIcon: <Campaign />,
          subSort: 4,
          onClick: () => handleClickItemOpen(2, 3, '/CampaingSource', 'Circulares - Campañas'), 
        },
        {
          subCode: 'DEOP0027',
          subText: 'Registro Campañas',
          subIcon: <QrCodeScanner />,
          subSort: 5,
          onClick: () => handleClickItemOpen(2, 4, '/RegisterCampaing', 'Circulares - Registro Campañas'), 
        },
        {
          subCode: 'DEOP0028',
          subText: 'Mis Circulares',
          subIcon: <MarkUnreadChatAlt />,
          subSort: 6,
          onClick: () => handleClickItemOpen(2, 5, '/MyNewsletters', 'Circulares - Mis Circulares'), 
        },
      ]
    },
    {
      code: 'DEOPP0003',
      text: 'Talma ID',
      icon: <SensorOccupiedIcon />,
      sort: 4,
      onClick: () => handleClickItemOpen(3, -1, '', 'Talma ID'),
      subItems: [
        {
          subCode: 'DEOP0008',
          subText: 'Gestión Usuarios',
          subIcon: <PersonAddIcon />,
          subSort: 1,
          onClick: () => handleClickItemOpen(3, 0, '/UserQueryTalmaID', 'Gestión Usuarios - Talma ID')
        }
      ]
    },
    {
      code: 'DEOPP0008',
      text: 'Atención al Colaborador',
      icon: <Assignment />,
      sort: 5,
      onClick: () => handleClickItemOpen(4, -1, '', 'Soporte Ausentismos'),
      subItems: [
        {
          subCode: 'DEOP0034',
          subText: 'Registrar Soporte Ausentismo',
          subIcon: <ContentPaste />,
          subSort: 1,
          onClick: () => handleClickItemOpen(4, 0, '/RegisterAbsenteeismSupport', 'Registrar Soporte Ausentismos')
        },
        {
          subCode: 'DEOP0035',
          subText: 'Consultar Soporte Ausentismo',
          subIcon: <ContentPasteSearch />,
          subSort: 2,
          onClick: () => handleClickItemOpen(4, 1, '/ConsultAbsenteeismSupport', 'Comsultar Soporte Ausentimos')
        },
        {
          subCode: 'DEOP0033',
          subText: 'Admin. Ausencias y Permisos',
          subIcon: <SupervisorAccountIcon />,
          subSort: 3,
          onClick: () => handleClickItemOpen(4, 2, '/EmployeeAbsencePermissionsAdmin', 'Admin Ausencias y Permisos - Autogestión')
        },
        {
          subCode: 'DEOP0036',
          subText: 'Consultar Ausencias y Permisos',
          subIcon: <PersonSearch />,
          subSort: 4,
          onClick: () => handleClickItemOpen(4, 3, '/EmployeeAbsencePermissionsConsult', 'Consultar Ausencias y Permisos ')
        },       
        {
          subCode: 'DEOP0037',
          subText: 'Consultar Solicitudes de Vacaciones',
          subIcon: <TravelExplore />,
          subSort: 5,
          onClick: () => handleClickItemOpen(4, 4, '/VacationRequestConsult', 'Consultar Solicitudes de Vacaciones')
        }
      ]
    },
    {
      code: 'DEOPP0005',
      text: 'Gestión Accesos',
      icon: <ManageAccountsRounded/>,
      sort: 6,
      onClick: () => handleClickItemOpen(5, -1, '', 'Gestión'),
      subItems: [
        {
          subCode: 'DEOP0018',
          subText: 'Maestro Perfiles',
          subIcon: <GroupAdd  />,
          subSort: 1,
          onClick: () => handleClickItemOpen(5, 0, '/manageposition', 'Maestro Perfiles')
        },
        {
          subCode: 'DEOP0007',
          subText: 'Perfiles Por Cargo',
          subIcon: <SettingsAccessibility />,
          subSort: 2,
          onClick: () => handleClickItemOpen(5, 1, '/manageprofileoptions', 'Perfiles Por Cargo')
        },
        {
          subCode: 'DEOP0019',
          subText: 'Perfiles Adi. Por Empleado',
          subIcon: <BadgeRounded  />,
          subSort: 3,
          onClick: () => handleClickItemOpen(5, 2, '/manageemployee', 'Perfiles Adi. Por Empleado')
        },
        {
          subCode: 'DEOP0020',
          subText: 'Aeropuertos Adi. Por Empleado',
          subIcon: <Flight  />,
          subSort: 4,
          onClick: () => handleClickItemOpen(5, 3, '/manageairport', 'Aeropuertos Adi. Por Empleado')
        },
        {
          subCode: 'DEOP0029',
          subText: 'Compañias Adi. Por Empleado',
          subIcon: <Domain  />,
          subSort: 4,
          onClick: () => handleClickItemOpen(5, 4, '/managecompany', 'Compañias Adi. Por Empleado')
        },
        {
          subCode: 'DEOP0030',
          subText: 'Zonas Adi. Por Empleado',
          subIcon: < MyLocation />,
          subSort: 5,
          onClick: () => handleClickItemOpen(5, 5, '/managezone', 'Zonas Adi. Por Empleado')
        },
        {
          subCode: 'DEOP0039',
          subText: 'Usabilidad',
          subIcon: < Policy />,
          subSort: 6,
          onClick: () => handleClickItemOpen(5, 6, '/manageusability', 'Usabilidad')
        }
      ]
    },
    {
      code: 'DEOPP0006',
      text: 'Gestión Compensación',
      icon: <PointOfSale/>,
      sort: 7,
      onClick: () => handleClickItemOpen(6, -1, '/', 'Gestión Compensación'),
      subItems: [
        {
          subCode: 'DEOP0021',
          subText: 'Requeridos',
          subIcon: <EmojiPeople />,
          subSort: 1,
          onClick: () => handleClickItemOpen(6, 0, '/Compensation', 'Requeridos')
        }
      ]
    },
    {
      code: 'DEOPP0007',
      text: 'Homologación Cargos',
      icon: <SettingsAccessibility/>,
      sort: 8,
      onClick: () => handleClickItemOpen(7, -1, '/', 'Homologación Cargos'),
      subItems: [
        {
          subCode: 'DEOP0022',
          subText: 'Inform',
          subIcon: <SocialDistance />,
          subSort: 1,
          onClick: () => handleClickItemOpen(7, 0, '/positionhomologationinform', 'Inform')
        },
        {
          subCode: 'DEOP0023',
          subText: 'Engrana',
          subIcon: <SocialDistance />,
          subSort: 2,
          onClick: () => handleClickItemOpen(7, 1, '/positionhomologationengrana', 'Engrana')
        },
        {
          subCode: 'DEOP0024',
          subText: 'Consultar Grupos Homologación',
          subIcon: <ManageSearch />,
          subSort: 3,
          onClick: () => handleClickItemOpen(7, 2, '/positionHomologationReadOnly', 'Consultar Grupos Homologación')
        }
      ]
    },
    {
      code: 'DEOPP0004',
      text: 'Admin. Turnos',
      icon: <EventNoteIcon />,
      sort: 9,
      onClick: () => handleClickItemOpen(8, -1, '', 'Admin. Turnos'),
      subItems: [
        {
          subCode: 'DEOP0016',
          subText: 'Consultar Turnos',
          subIcon: <AccessTimeIcon />,
          subSort: 1,
          onClick: () => handleClickItemOpen(8, 0, '/ShiftReadOnly', 'Consultar readOnly - Turnos')
        },
        {
          subCode: 'DEOP0025',
          subText: 'Consultar Abreviados',
          subIcon: <ShortTextIcon />,
          subSort: 2,
          onClick: () => handleClickItemOpen(8, 1, '/ShiftAbbreviationReadOnly', 'Consultar readOnly - Abreviados')
        },
        {
          subCode: 'DEOP0032',
          subText: 'Consultar Áreas',
          subIcon: <LineWeight />,
          subSort: 3,
          onClick: () => handleClickItemOpen(8, 2, '/AreaReadOnly', 'Consultar readOnly - Área')
        },
        {
          subCode: 'DEOP0009',
          subText: 'Maestro Turnos',
          subIcon: <MoreTimeIcon />,
          subSort: 4,
          onClick: () => handleClickItemOpen(8, 3, '/ShiftManagement', 'Turnos - Turnos')
        },
        {
          subCode: 'DEOP0010',
          subText: 'Maestro Abreviados',
          subIcon: <PlaylistAdd />,
          subSort: 5,
          onClick: () => handleClickItemOpen(8, 4, '/ShiftAbbreviation', 'Abreviados - Turnos')
        },
        {
          subCode: 'DEOP0031',
          subText: 'Maestro Áreas',
          subIcon: <LineStyleIcon   />,
          subSort: 6,
          onClick: () => handleClickItemOpen(8, 5, '/Area', 'Áreas - Turnos')
        },
        {
          subCode: 'DEOP0011',
          subText: 'Consultar Programación',
          subIcon: <CalendarMonthIcon />,
          subSort: 7,
          onClick: () => handleClickItemOpen(8, 6, '/ShiftHistory', 'Consultar - Turnos')
        },

        {
          subCode: 'DEOP0040',
          subText: 'Consultar Cambios de Turnos',
          subIcon: <ChangeCircleOutlined />,
          subSort: 8,
          onClick: () => handleClickItemOpen(8, 7, '/ShiftHistoryChange', 'Consultar - Cambios Turnos')
        },
        {
          subCode: 'DEOP0013',
          subText: 'Importar Programación',
          subIcon: <CloudUploadIcon />,
          subSort: 9,
          onClick: () => handleClickItemOpen(8, 8, '/ShiftImport', 'Importar - Turnos')
        }
      ]
    },
  ]);

  itemList.sort((x, z) => x.sort - z.sort);

  const verifyOption = (option) => {
    if(!user) {
      sessionStorage.clear();
      return false;
    }
    
    if(user.companies.length > 1 && user.company == null){
      sessionStorage.clear();
      return false;
    }
     
    
    return user?.employeePosition.employeePositionOptions.some(x=> x.code === option || option === "0");
  };

  return (
    <>
      {message && <AcceptDialog 
        handleClose= {() => {setMessage(null);}}
        dialogContentText ={message}
        dialogTitle={MESSAGES.ALERT}
        handleAccept ={() => logout()}
        open={message}
      />}
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" open={open}>
        {user && <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(open && { display: 'none' }) }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {TITLES.DRAWER}
            </Typography>
            {/* <Button color="inherit" onClick={() => {
                  setMessage(MESSAGES.CONFIRM_EXIT);
                }}
               >Salir</Button> */}
              
            <Box display="flex" alignItems="center" gap={2}> 
              <Tooltip title={companyName}>
                <Typography 
                  variant="subtitle1" 
                  style={{
                    fontWeight: 'bold',
                    color: '#ffffff',
                    backgroundColor: '#1976D2',
                    padding: '5px 10px', 
                    borderRadius: '5px'
                  }}
                >
                  {companyName}
                </Typography>
              </Tooltip>

              <Tooltip title={user.name + ' ' + user.lastName}>
                <Avatar 
                  style={{
                    backgroundColor: 'rgb(0, 176, 239)',
                    marginLeft: '10px'
                  }}
                >
                  {user ? `${user.name[0]}${user.lastName[0]}` : ''}
                </Avatar>
              </Tooltip>
            </Box>

            <Tooltip title="Salir">
              <IconButton aria-label="Example" onClick={() => {
                  setMessage(MESSAGES.CONFIRM_EXIT);
                }}>
                <ExitToAppIcon style={{color: 'white'}}/>
              </IconButton>
            </Tooltip>
          </Toolbar>}
        </AppBar>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          <DrawerHeader>
            <img src="./Images/Logo_Tu_Experiencia_Talma_fondo_azul.png" alt="logo" style={logoStyles} />
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List
            sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            
            {
              itemList.map((item, index) => {
                
                const { code, text, icon, onClick, subItems} = item;

                // Verificar si es único menú o tiene submenú

                if(subItems.length === 0){
                  return (
                    verifyOption(code) && 
                    <>
                      <ListItemButton selected={selectedIndexMenu[0] === index} key={index} onClick={onClick}>
                        <ListItemIcon>
                          {icon}
                        </ListItemIcon>
                        <ListItemText primary={text} />
                      </ListItemButton>
                    </>
                  );
                }else{

                  return (
                    verifyOption(code) &&
                    <>
                      <ListItemButton selected={selectedIndexMenu[0] === index && selectedIndexMenu[1] === -1} onClick={onClick}>
                        <ListItemIcon>
                          {icon}
                        </ListItemIcon>
                        <ListItemText primary={text} />
                        {openMenuIndex && selectedIndexMenu[0] === index ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                      <Collapse in={openMenuIndex === index} timeout="auto" unmountOnExit>
                        {
                          subItems.map((subItem, subIndex) => {

                            const { subCode, subText, subIcon, onClick} = subItem;
                            
                            return (
                              verifyOption(subCode) &&
                              <>
                                <List component="div" disablePadding>
                                  <ListItemButton selected={selectedIndexMenu[0] === index && selectedIndexMenu[1] === subIndex} 
                                  sx={{ pl: 4 }} 
                                  onClick={onClick}>
                                    <ListItemIcon>
                                      {subIcon}
                                    </ListItemIcon>
                                    <ListItemText primary={subText} />
                                  </ListItemButton>
                                </List>
                              </>
                            );
        
                          })
                        }
                       </Collapse>
                    </>
                  );
                }
              })
            }
          </List>
        </Drawer>
        <Main open={open}>
          <DrawerHeader />
              <Routes>
                  <Route path="/changePassword/:key" 
                          element={<UpdatePassword />}/>
                  <Route path="/" 
                    element={!user ? <Login /> :<Home />}/>
                  <Route path="/Overtime" 
                      element={!user ? <Login /> :<Overtime />}/>
                  <Route path="/EmployeeWorkShif" 
                      element={!user ? <Login /> : <EmployeeWorkShif isDrawerOpen={open}/> }
                      />
                  {/* <Route path="/PolyvalencePayment" 
                      element={!user ? <Login /> : <PolyvalencePayment /> }
                      /> */}
                  <Route path="/NewsletterType" 
                      element={!user ? <Login /> : verifyOption('DEOP0004') && <NewsletterType /> }
                      />
                  <Route path="/Newsletter" 
                      element={!user ? <Login /> : verifyOption('DEOP0005') && <Newsletter /> }
                      />
                  <Route path="/CampaingSource" 
                      element={!user ? <Login /> : verifyOption('DEOP0026') && <CampaingSource /> }
                      />
                  <Route path="/RegisterCampaing" 
                      element={!user ? <Login /> : verifyOption('DEOP0027') && <RegisterCampaign /> }
                      />
                  <Route path="/MyNewsletters" 
                      element={!user ? <Login /> : verifyOption('DEOP0028') && <PendingNewslettersSource /> }
                      />
                  <Route path="/PendingSignatures" 
                      element={!user ? <Login /> : verifyOption('DEOP0006') && <PendingSignatures /> }
                      />
                  <Route path="/Signature/:key" 
                      element={!user ? <Login /> : verifyOption('DEOP0006') && <Signature /> }
                      />
                  <Route path="/manageprofileoptions" 
                      element={!user ? <Login /> : verifyOption('DEOP0007') && <ManageProfileOptions /> }
                      />
                  <Route path="/manageposition" 
                      element={!user ? <Login /> : verifyOption('DEOP0018') && <ManagementProfile /> }
                      />
                  <Route path="/manageemployee" 
                      element={!user ? <Login /> : verifyOption('DEOP0019') && <ManagementEmployee /> }
                      />
                  <Route path="/manageairport" 
                      element={!user ? <Login /> : verifyOption('DEOP0020') && <ManagementAirport /> }
                      />  
                  <Route path="/managezone" 
                      element={!user ? <Login /> : verifyOption('DEOP0030') && <ManagementZone /> }
                      />
                   <Route path="/manageusability" 
                      element={!user ? <Login /> : verifyOption('DEOP0039') && <ManagementUsability /> }
                      />
                  <Route path="/managecompany" 
                      element={!user ? <Login /> : verifyOption('DEOP0029') && <ManagementCompany /> }
                      />  
                  <Route path="/compensation" 
                      element={!user ? <Login /> : verifyOption('DEOP0021') && <Compensation /> }
                      />
                  <Route path="/positionhomologationinform" 
                    element={!user ? <Login /> : verifyOption('DEOP0022') && <PositionHomologationInform /> }
                    />
                  <Route path="/positionhomologationengrana" 
                    element={!user ? <Login /> : verifyOption('DEOP0023') && <PositionHomologationEngrana /> }
                    />
                  <Route path="/positionHomologationReadOnly" 
                    element={!user ? <Login /> : verifyOption('DEOP0024') && <GroupHomologationReadOnly /> }
                    />
                  <Route path="/UserQueryTalmaID" 
                      element={!user ? <Login /> : verifyOption('DEOP0008') && <UserQueryTalmaID /> }
                      />
                  <Route path="/RegisterAbsenteeismSupport" 
                      element={!user ? <Login /> : verifyOption('DEOP0034') && <AbsenteeismSupport /> }
                      />
                  <Route path="/ConsultAbsenteeismSupport" 
                      element={!user ? <Login /> : verifyOption('DEOP0035') && <AbsenteeismSupportConsult /> }
                      />
                  <Route path="/ShiftManagement" 
                      element={!user ? <Login /> : verifyOption('DEOP0009') && <ShiftManagement /> }
                      />
                  <Route path="/ShiftSegments/:sId" 
                      element={!user ? <Login /> : verifyOption('DEOP0009') && <ShiftSegments /> }
                      />
                  <Route path="/ShiftAbbreviation" 
                      element={!user ? <Login /> : verifyOption('DEOP0010') && <ShiftAbbreviation /> }
                      />
                  <Route path="/ShiftHistory" 
                      element={!user ? <Login /> : verifyOption('DEOP0011') && <ShiftHistory /> }
                      />
                  <Route path="/ShiftHistoryChange" 
                      element={!user ? <Login /> : verifyOption('DEOP0040') && <ShiftHistoryChange /> }
                      />
                  <Route path="/Assessment" 
                      element={!user ? <Login /> : verifyOption('DEOP0012') && <Assessment /> }
                      />
                  <Route path="/ShiftImport" 
                      element={!user ? <Login /> : verifyOption('DEOP0013') && <ShiftImport /> }
                      />
                  <Route path="/ShiftCalendar" 
                      element={!user ? <Login /> : <ShiftCalendar isDrawerOpen={open}/> }
                      />
                  <Route path="/EmployeeAbsencePermissions" 
                      element={!user ? <Login /> : verifyOption('DEOP0015') && <EmployeeAbsencePermissions /> }
                      />
                  <Route path="/EmployeeAbsencePermissionsAdmin" 
                      element={!user ? <Login /> : verifyOption('DEOP0033') && <EmployeeAbsencePermissionsAdmin /> }
                      />
                  <Route path="/EmployeeAbsencePermissionsConsult" 
                      element={!user ? <Login /> : verifyOption('DEOP0036') && <EmployeeAbsencePermissionsConsult /> }
                      />
                  <Route path="/ShiftReadOnly" 
                      element={!user ? <Login /> : verifyOption('DEOP0016') && <ShiftReadOnly /> }
                      />
                  <Route path="/ShiftAbbreviationReadOnly" 
                      element={!user ? <Login /> : verifyOption('DEOP0025') && <ShiftAbbreviationReadOnly /> }
                      />
                  <Route path="/Area" 
                      element={!user ? <Login /> : verifyOption('DEOP0031') && <Area /> }
                      />
                  <Route path="/AreaReadOnly" 
                      element={!user ? <Login /> : verifyOption('DEOP0032') && <AreaReadOnly /> }
                      />
                  <Route path="/VacationRequest" 
                      element={!user ? <Login /> : verifyOption('DEOP0038') && <VacationRequest /> }
                      />
                  <Route path="/VacationRequestConsult" 
                      element={!user ? <Login /> : verifyOption('DEOP0037') && <VacationRequestConsult /> }
                      />
              </Routes>
        </Main>
      </Box>
    </>
  );
}

  
  export default Dashboard;